import * as React from 'react';

import * as style from './styles.css';
import { UIHeading3, Image, Skeleton } from '@cian/ui-kit';
import stars from '../assets/starsLight.svg';
import { randomSummaryTextList, useTypewriterPhrases } from '../../AiSummaryModalShared/utils';

export interface ILoadingScreenProps {
  onComplete?: () => void;
}

export const LoadingScreen = ({ onComplete }: ILoadingScreenProps): React.JSX.Element => {
  const { announcedPhrase, phase, typedText } = useTypewriterPhrases(randomSummaryTextList);
  const hasCompletedRef = React.useRef(false);

  React.useEffect(() => {
    if (phase === 'completed' && !hasCompletedRef.current) {
      hasCompletedRef.current = true;
      onComplete?.();
    }
  }, [onComplete, phase]);

  return (
    <>
      <div className={style['loading-navbar-container']}>
        <div className={style['navbar-stub']} />
        <div className={style['navbar-stub']} />
        <div className={style['navbar-stub']} />
      </div>
      <div className={style['loading-building-card-container']}>
        <div className={style['loading-facts-container']}>
          <div className={style['first-fact-stub']} />
          <div className={style['second-fact-stub']} />
        </div>
        <div className={style['third-fact-stub']} />
      </div>
      <div className={style['loading-content-container']}>
        <div className={style['rotate-text-wrapper']}>
          <Image height={24} src={stars} width={24} />
          <div
            aria-hidden="true"
            className={`${style['phrase']} ${phase === 'exiting' ? style['phrase-exiting'] : ''}`}
            data-phase={phase}
            data-testid="ai-summary-loading-phrase"
          >
            <div className={style['phrase-text']}>
              <UIHeading3 color="text-secondary-default">{typedText}</UIHeading3>
            </div>
          </div>
          <span aria-atomic="true" aria-live="polite" className={style['visually-hidden']}>
            {announcedPhrase}
          </span>
        </div>
        <div className={style['skeleton-wrapper']}>
          <Skeleton width={212} height={12} borderRadius={12} />
          <Skeleton width={212} height={12} borderRadius={12} />
          <Skeleton width={149} height={12} borderRadius={12} />
        </div>
      </div>
    </>
  );
};
